// ============================================
// УТИЛИТЫ ДЛЯ ВАЛИДАЦИИ ФОРМ
// ============================================

// Функция для форматирования номера телефона в block7
function formatBlock7Phone(value) {
  // Убираем все символы кроме цифр и +
  let cleaned = value.replace(/[^\d+]/g, '');
  
  // Если номер не начинается с +, добавляем его
  if (cleaned && !cleaned.startsWith('+')) {
    cleaned = '+' + cleaned;
  }
  
  // Автоматически подставляем +998 если начали вводить +9 (только в начале, когда после +9 нет других цифр)
  if (cleaned === '+9' || cleaned === '+99') {
    // Если ввели только +9 или +99 (без дополнительных цифр), автоматически подставляем +998
    cleaned = '+998';
  }
  
  // Проверяем, что после + идет только 7 или 998
  if (cleaned.startsWith('+')) {
    const afterPlus = cleaned.slice(1);
    // Если после + идет что-то, что не начинается с 7 или 998, очищаем
    if (afterPlus) {
      // Если это одна цифра, разрешаем только 7 или 9
      if (afterPlus.length === 1 && afterPlus !== '7' && afterPlus !== '9') {
        return '';
      }
      // Если это две цифры, разрешаем только начинающиеся с 7 или 99
      if (afterPlus.length === 2 && !afterPlus.startsWith('7') && !afterPlus.startsWith('99')) {
        return '';
      }
      // Если это три цифры, разрешаем только начинающиеся с 7 или равные 998
      if (afterPlus.length === 3 && afterPlus !== '998' && !afterPlus.startsWith('7')) {
        return '';
      }
      // Если это больше трех цифр, разрешаем только начинающиеся с 7 или 998
      if (afterPlus.length > 3 && !afterPlus.startsWith('7') && !afterPlus.startsWith('998')) {
        return '';
      }
    }
  }
  
  // Определяем код страны
  // Сначала проверяем +998, так как он длиннее
  if (cleaned.startsWith('+998')) {
    // Для +998: ограничение 9 цифр после +998
    // Извлекаем все цифры и убираем первые 3 (998) - только первую группу 998
    const allDigits = cleaned.replace(/[^\d]/g, '');
    // Убираем только первую группу "998" (код страны)
    let digits = '';
    if (allDigits.startsWith('998')) {
      digits = allDigits.slice(3); // Убираем первую "998"
    }
    
    // Ограничиваем до 9 цифр (единственное правило)
    if (digits.length > 9) {
      digits = digits.slice(0, 9);
    }
    
    // Форматируем: +998 XX XXX XX XX
    let formatted = '+998';
    if (digits.length > 0) {
      formatted += ' ' + digits.slice(0, 2);
    }
    if (digits.length > 2) {
      formatted += ' ' + digits.slice(2, 5);
    }
    if (digits.length > 5) {
      formatted += ' ' + digits.slice(5, 7);
    }
    if (digits.length > 7) {
      formatted += ' ' + digits.slice(7, 9);
    }
    return formatted.trim();
  } else if (cleaned.startsWith('+7')) {
    // Для +7: ограничение 10 цифр после +7
    let digits = cleaned.replace(/[^\d]/g, '').slice(1); // Убираем + и первую 7
    if (digits.length > 10) {
      digits = digits.slice(0, 10);
    }
    
    // Форматируем: +7 XXX XXX XX XX
    let formatted = '+7';
    if (digits.length > 0) {
      formatted += ' ' + digits.slice(0, 3);
    }
    if (digits.length > 3) {
      formatted += ' ' + digits.slice(3, 6);
    }
    if (digits.length > 6) {
      formatted += ' ' + digits.slice(6, 8);
    }
    if (digits.length > 8) {
      formatted += ' ' + digits.slice(8, 10);
    }
    return formatted.trim();
  } else if (cleaned.startsWith('+')) {
    // Если начинается с +, но не +7 и не +998, проверяем, может ли это быть началом +7 или +998
    const afterPlus = cleaned.slice(1);
    // Если после + идет что-то, что может быть началом +7, разрешаем
    if (afterPlus.startsWith('7')) {
      return cleaned; // Разрешаем продолжение ввода для +7
    }
    // Для +9 и +99 уже автоматически подставляется +998 выше
    // Иначе не принимаем
    return '';
  }
  
  return cleaned;
}

// Функция для валидации номера телефона в block7
function validateBlock7Phone(value) {
  if (!value) return false;
  
  // Получаем код страны из селектора (ищем элемент напрямую)
  const phoneCodeBlock7 = document.getElementById("phoneCodeBlock7");
  const code = phoneCodeBlock7 ? phoneCodeBlock7.textContent.trim() : '+7';
  const isUzbekistan = code === '+998';
  
  // Убираем все нецифровые символы (пробелы и т.д.)
  const digitsOnly = value.replace(/\D/g, '');
  
  // Проверяем количество цифр в зависимости от кода страны
  const requiredDigits = isUzbekistan ? 9 : 10;
  
  return digitsOnly.length === requiredDigits;
}

// Экспортируем функции валидации глобально
window.validateBlock7Phone = validateBlock7Phone;
window.formatBlock7Phone = formatBlock7Phone;
window.validatePhone = validatePhone;
window.validateEmail = validateEmail;
window.validateBirthDate = validateBirthDate;

// Функция валидации телефона (общая, для форм с intl-tel-input)
function validatePhone(phoneInput, itiInstance) {
  if (!phoneInput) return false;
  
  const phoneNumber = phoneInput.value.trim();
  if (!phoneNumber) return false;
  
  // Проверка через intl-tel-input, если он инициализирован
  if (itiInstance && typeof itiInstance.isValidNumber === 'function') {
    try {
      if (itiInstance.isValidNumber()) {
        return true;
      }
    } catch (e) {
      console.log('intl-tel-input validation error:', e);
    }
  }
  
  // Дополнительная проверка: определяем количество цифр в зависимости от региона
  const digitsOnly = phoneNumber.replace(/\D/g, '');
  
  // Определяем регион по коду страны или по текущему региону
  let isUzbekistan = false;
  if (phoneInput.closest('.phone_wrapper')) {
    const phoneCodeEl = phoneInput.closest('.phone_wrapper').querySelector('.phone-code');
    if (phoneCodeEl && phoneCodeEl.textContent.trim() === '+998') {
      isUzbekistan = true;
    }
  }
  
  // Проверяем количество цифр: для Узбекистана - 9, для России - 10
  const requiredDigits = isUzbekistan ? 9 : 10;
  if (digitsOnly.length >= requiredDigits) {
    return true;
  }
  
  return false;
}

// Функция валидации email
function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

// Функция проверки антибота (добавлена сюда для ранней доступности)
function checkAntibot(userAnswer, correctAnswer) {
  if (!userAnswer || !userAnswer.trim()) return false;
  
  const answer = parseInt(userAnswer.trim(), 10);
  if (isNaN(answer)) return false;
  
  return answer === correctAnswer;
}

// Экспортируем функцию глобально СРАЗУ после определения для использования в других модулях
window.checkAntibot = checkAntibot;

// Также экспортируем в глобальную область видимости для совместимости
if (typeof globalThis !== 'undefined') {
  globalThis.checkAntibot = checkAntibot;
}

// Функция валидации даты рождения (xx.xx.xxxx)
function validateBirthDate(date) {
  const dateRegex = /^(\d{2})\.(\d{2})\.(\d{4})$/;
  const match = date.match(dateRegex);
  if (!match) return false;
  
  const day = parseInt(match[1], 10);
  const month = parseInt(match[2], 10);
  const year = parseInt(match[3], 10);
  
  // Проверка диапазонов
  if (day < 1 || day > 31) return false;
  if (month < 1 || month > 12) return false;
  if (year < 1900 || year > new Date().getFullYear()) return false;
  
  return true;
}

